import React, { Component } from 'react'
import {Container,Row,Col,Button,Modal,ModalBody} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { connect } from 'react-redux';
import { 
  faAngleLeft, faAngleRight, faPlus
 } from '@fortawesome/free-solid-svg-icons'
import { addCarPhotos } from '../../slices/modalSlice';


class AddImages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      photoModalOpen:false,
      imgUrl:[],
      alertMaxPic : false,
      files : []
    }
    this.toogleClosePhotos = this.toogleClosePhotos.bind(this);   
  };

  toogleClosePhotos =()=> this.props.dispatch(addCarPhotos())

  onChangeUpload(e) {
    if (this.state.imgUrl.length<=4) {
      this.setState({files:e.target.files[0]});
   e.preventDefault();

   const file =  e.target.files[0]

   this.setState({
        files: [...this.state.files,file]
  })

   const fileReader = new FileReader();
   fileReader.onload = () => {
   this.setState({imgUrl: [...this.state.imgUrl,fileReader.result]});
   }
   fileReader.readAsDataURL(file);
  }

    else(
      this.setState({
        alertMaxPic : true
      })
    )
}

  render() {
    const imag0 = this.state.imgUrl[0]
    const imag1 = this.state.imgUrl[1]
    const imag2 = this.state.imgUrl[2]
    const imag3 = this.state.imgUrl[3]
    const imag4 = this.state.imgUrl[4]
    return (
        <Modal isOpen={false} toggle={this.toogleClosePhotos}  className="modal-width-images-announce">
        <nav className="nav-windows-addanounce">
        <button className="close-heberg"  onClick={this.toogleClosePhotos} >
          <span>X</span>
        </button>
        <div className="title-announce" >
          Nouvelle Annonce Location
        </div>
        </nav>

        <div className="path-heberg">
          <div className="item-path-hebrg" >

          <div className="number-path">
            <span className="number-path-value">1</span>
          </div>

          <span className="name-path" >
              Détails
              <FontAwesomeIcon className="icon-path"  icon={faAngleRight} />

          </span>

          </div>

          <div className="item-path-hebrg" style={{backgroundColor:"#37296a"}}>

             <div className="number-path" style={{backgroundColor:"white"}} >
               <span className="number-path-value" style={{color:"#37296a"}} >2</span>
             </div>

            <span className="name-path" style={{color:"white"}}>
                Photos
                <FontAwesomeIcon className="icon-path"  icon={faAngleRight} />

            </span>

         </div>

         <div className="item-path-hebrg">

             <div className="number-path">
               <span className="number-path-value">3</span>
             </div>

            <span className="name-path last-path">
                Agenda
                <FontAwesomeIcon className="icon-path"  icon={faAngleRight} />

            </span>
         </div>
        </div>

        <ModalBody style={{marginTop:"100px"}}>
          <Container>
            <Row>
              <Col md="7" style={{paddingRight: "0px"}}>
                <div className="test" style={{width:"100%",height:"400px"}}>
                  {
                    imag0 &&
                    <>
                      <img src={this.state.imgUrl[0]} className="img-add-ann" alt=""/>
                    </>
                  }

                 {
                    !imag0 &&
                    <>
                      <img src="/imgs/announces/firstAnn.png" className="img-add-ann" alt=""/>
                    </>
                  }

                </div>
              </Col>

              <Col md="5">

                <Row className="row-half-height">
                  <Col sm="6" className="padding0 pdt">
                  {
                    imag1 &&
                    <>
                      <img src={this.state.imgUrl[1]} className="img-add-ann-small" alt=""/>
                    </>
                  }

                 {
                    !imag1 &&
                    <>
                      <img src="/imgs/announces/firstAnn.png" className="img-add-ann-small" alt=""/>
                    </>
                  }                    
                  </Col>

                  <Col sm="6" className="padding0 pdt">
                  {
                    imag2 &&
                    <>
                      <img src={this.state.imgUrl[2]} className="img-add-ann-small" alt=""/>
                    </>
                  }

                 {
                    !imag2 &&
                    <>
                      <img src="/imgs/announces/firstAnn.png" className="img-add-ann-small" alt=""/>
                    </>
                  }                    
                  </Col>
                </Row>
                
                <Row className="row-half-height">
                <Col sm="6" className="last-child-image padding0 pdt">
                {
                    imag3 &&
                    <>
                      <img src={this.state.imgUrl[3]} className="img-add-ann-small" alt=""/>
                    </>
                  }

                 {
                    !imag3 &&
                    <>
                      <img src="/imgs/announces/firstAnn.png" className="img-add-ann-small" alt=""/>
                    </>
                  }                  
                  </Col>
                <Col sm="6" className="last-child-image padding0 pdt">
                {
                    imag4 &&
                    <>
                      <img src={this.state.imgUrl[4]} className="img-add-ann-small" alt=""/>
                    </>
                  }

                 {
                    !imag4 &&
                    <>
                      <img src="/imgs/announces/firstAnn.png" className="img-add-ann-small" alt=""/>
                    </>
                  }                   
                  </Col>
                </Row>

              </Col>

            </Row>

            <center className="files-upload-btn">

            <form  enctype="multipart/form-data">

               <label for='upload-photo' className="button-add-moule add-imgs-button" > <span id="ajouter-text"><FontAwesomeIcon  icon={faPlus} />Ajouter des photos</span></label>
               {this.state.imgUrl.length >= 5 && <p style={{color:"red"}}>Max 5 photos</p>}
               <input type="file" name="myImage[]" id="upload-photo" disabled={this.state.imgUrl.length >= 5}
                onChange={this.onChangeUpload.bind(this)} 
               />
               {/* <input type="text" name="imageUrl" placeholder="image url" /> */}

            </form>

            </center>

            <br/> <br/>
            <h6 style={{color:"rgb(119, 113, 113)"}}>Ps : Vous pouvez télecharger jusqu'a 4 photos a la fois ,sous formats JPEG,PNG,BMP ou TIFF</h6>
            <Row>
              <div className="buttons-add-announce-photos">
                <Button className=" button-add-moule retour-button" onClick={this.retourAddHeberg}><FontAwesomeIcon id="arrow-retour"  icon={faAngleLeft} />Retour</Button>
                <Button className=" button-add-moule suivant-button" 
                >Valider<FontAwesomeIcon id="arrow-suivant"  icon={faAngleRight} /></Button>
              </div>
            </Row>
          </Container>
        </ModalBody>
        </Modal>
    )
  }
}

function mapStateToProps(state) {
  return {
    addAnn: state.modal.addAnn,
    addHeberg : state.modal.addHeberg,
    addCarPh : state.modal.addCarPh
  }
}
//connect function INJECTS dispatch function as a prop!!
export default connect(mapStateToProps)(AddImages);